import { getEnvironment } from 'src/config';

import {
  IMAGE_SERVICE_URL_PROD,
  IMAGE_SERVICE_URL_DEV,
} from 'src/constants/urls';
import { Environment } from 'src/types';

export const getUploadUrl = (): string =>
  getEnvironment() === Environment.PROD
    ? IMAGE_SERVICE_URL_PROD
    : IMAGE_SERVICE_URL_DEV;
